<template>
    <b-modal size="xl" style="max-width: 80%!important;" ref="ipoteka-bank-transaction-add-edit-modal" :title="$t('finance.ipoteka.bindToObject')"
             @ok="okBtn"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true">
    <div class="container-fluid">

        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row mb-3 align-items-center justify-content-between">
                        <div class="m-1">
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div class="m-1">
                            <p class="font-weight-bold m-0">{{ippotekaTransactionData!=null? 'Сумма: ' + ippotekaTransactionData.reminderAfterSharing : ''}}</p>
                        </div>
                        <div class="m-1">
                            <p class="font-weight-bold red m-0">{{'Танланган Сумма: ' + selectSumma}}</p>
                        </div>
                        <div class="m-1" v-if="evaluationObjects.length>0">
                            <button class="all-btn" @click="bindTransactionToObject" v-if="hasPermission('IPOTEKA_BANK_BIND_TRANSACTIONS')">
                                {{$t("finance.ipoteka.bindToObject")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-3 col-lg-6 col-12 mb-2" v-if="organizationListValue.data && organizationListValue.data.length > 0">
                                <label>{{$t("accounting.account.organization")}}</label>
                                <select class="form-control" v-model="filter.organizationType"
                                        @change="onOrganizationTypeChange">
                                    <option value="" v-if="organizationListValue.data.length === organizationListValue.total"></option>
                                    <option :value="option.code" v-for="option in organizationListValue.data"
                                            :key="option.code">
                                        {{option.displayName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-12 mb-2">
                                <label>{{$t("accounting.account.province")}}</label>
                                <v-select v-model="filter.province" label="name"
                                          :options="provinces"
                                          :filterable="false"
                                          :disabled="regionalLeaderProvince!=null"
                                          @search="onProvinceGetRegionsChange"
                                          @change="onProvinceGetRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-lg-6 col-12 mb-2">
                                <label>{{$t("accounting.account.city")}} ва
                                    {{$t("accounting.account.district")}}</label>
                                <v-select v-model="filter.region" label="name"
                                          :options="regions"
                                          :filterable="false"
                                          @search="searchByFilter"
                                          @change="searchByFilter">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("accounting.account.executiveJob")}}
                                    {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.letterNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("accounting.account.contract")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberContract" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("accounting.account.invoice")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.invoiceNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                                <label>{{$t("accounting.account.report")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberReport" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-sm-6 col-12 mb-2">
                                <label>{{$t("accounting.account.identificationNumber")}}</label>
                                <input type="text" class="form-control" v-model="filter.identificationNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-sm-6 col-12 mb-2">
                                <label>{{$t("report.field.fullName")}} yoki
                                    {{$t("accounting.account.organization")}}</label>
                                <input type="text" class="form-control" v-model="filter.search" @change="searchByFilter"/>
                            </div>
                            <!--<div class="col-sm-2">-->
                                <!--<label>{{$t("report.field.pays")}}<br/>-->
                                    <!--<input type="checkbox" v-model="filter.paid"/>-->
                                <!--</label>-->
                            <!--</div>-->
                            <!--<div class="col-sm-2">-->
                                <!--<label>{{$t("report.field.unPaid")}}<br/>-->
                                    <!--<input type="checkbox" v-model="filter.unPaid"/>-->
                                <!--</label>-->
                            <!--</div>-->
                            <div class="col-xl-3 col-lg-3 col-sm-6 col-12 mb-2">
                                <label>{{$t("report.field.governmentNum")}}</label>
                                <input type="text" class="form-control" :placeholder="$t('report.field.car')" v-model="filter.governmentNum" @change="searchByFilter"/>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-sm-6 col-12 mb-2">
                                <label>{{$t("report.field.paymentStatus")}}</label>
                                <select class="form-control" v-model="filter.paymentStatus">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="PAID">{{$t('report.field.paymentStatusPaid')}}</option>
                                    <option value="UNPAID">{{$t('report.field.paymentStatusUnPaid')}}</option>
                                </select>
                            </div>
                            <div class="col-sm-1">
                                <label style="align-self: center">{{$t("main.search")}}</label>
                                <button class="all-btn form-control m-0 mb-2" @click="searchByFilter"
                                        style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                                    <i class="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <payment-document-list></payment-document-list>
                    <vat-payment-modal></vat-payment-modal>
                    <div class="card-body scroll-card-body">
                        <table class="customers">
                            <thead>
                            <tr>
                                <th rowspan="3">№</th>
                                <th rowspan="3">{{$t('accounting.account.objectType')}}</th>
                                <th rowspan="3">{{$t('accounting.account.createdUserName')}}</th>
                                <th colspan="10">{{organization}}</th>
                                <th colspan="2">{{$t("accounting.account.order")}}</th>
                                <th colspan="3">{{$t("accounting.account.report")}}</th>
                                <th colspan="6">{{$t("accounting.account.invoice")}}</th>
                                <th rowspan="3">{{$t("accounting.account.totalAmountQQS")}}</th>
                                <th colspan="6">{{$t("accounting.account.paymentDocument")}}</th>
                                <!--<th rowspan="3">{{$t("accounting.account.vatPayment")}}</th>-->
                                <th colspan="2">{{$t("accounting.account.debtBalance")}}</th>
                            </tr>
                            <tr>
                                <th rowspan="2">{{$t("accounting.account.province")}}</th>
                                <th rowspan="2">{{$t("accounting.account.city")}}{{$t("accounting.account.district")}}</th>
                                <th rowspan="2">{{$t("accounting.account.fullName")}}</th>
                                <th rowspan="2">{{$t("report.field.mibDebtorName")}}</th>
                                <th rowspan="2">{{$t("accounting.account.passportNumber")}}</th>
                                <th colspan="2">{{$t("accounting.account.executiveJob")}}</th>
                                <th rowspan="2">{{$t("accounting.account.identificationNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.bankMFO")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accountNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.feeService")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.jobName")}}</th>
                                <th rowspan="2">{{$t("accounting.account.priceWithoutQQS")}}</th>
                                <th colspan="2">{{$t("accounting.account.qqs")}}</th>
                                <!--<th rowspan="2">{{$t("accounting.account.esp")}}  {{$t("accounting.account.date")}}</th>-->
                                <!--<th rowspan="2">{{$t("accounting.account.esp")}}  {{$t("accounting.account.number")}}</th>-->
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.amountPrice")}}</th>
                                <th rowspan="2">{{$t("accounting.account.paymentSource")}}</th>
                                <th rowspan="2">{{$t("accounting.account.registrationPayDoc")}}</th>
                                <th rowspan="2">{{$t("accounting.account.registrationPayDoc")}}</th>
                                <th rowspan="2">{{$t("accounting.account.debtor")}}</th>
                                <th rowspan="2">{{$t("accounting.account.creditor")}}</th>
                            </tr>
                            <tr>
                                <th>{{$t("accounting.account.date")}}</th>
                                <th>{{$t("accounting.account.number")}}</th>
                                <th>{{$t("accounting.account.qqsRate")}}</th>
                                <th>{{$t("accounting.account.qqsAmount")}}</th>
                            </tr>

                            </thead>
                            <tbody>
                            <template v-if="results">
                                <tr v-for=" (result) in results.data" :key="result.id">
                                    <td> <a :href="getOpenLink(result)" target="_blank">{{result.id}}</a></td>
                                    <td>
                                        <span>{{result.evlObjectTypeDto!=null?result.evlObjectTypeDto.displayName: ''}}</span><br/>
                                        <span class="font-weight-bold">{{result.objectName!=null?result.objectName: ''}}</span>
                                    </td>
                                    <td>{{result.createdBy!=null?result.createdBy.name:''}}</td>
                                    <td>{{result.province}}</td>
                                    <td>{{result.region}}</td>
                                    <td>
                                        <div class="text-info">{{result.fullName}}</div>
                                        <div class="text-warning">{{result.firmName}}</div>
                                    </td>
                                    <td>
                                        <div class="text-info">{{result.debtorName}}</div>
                                    </td>
                                    <td>{{result.passportNumber}}</td>
                                    <td>{{result.letterDate}}</td>
                                    <td>{{result.letterNumber}}</td>
                                    <td>{{result.identificationNumber}}</td>
                                    <td>{{result.bankMFO}}</td>
                                    <td>{{result.accountNumber}}</td>
                                    <td>{{result.generateDateContract}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.generateNumberReport}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td>{{result.jobName}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <!--<td><a href="AccountingLegalAndPhysical.vue"> {{result.espDate}}</a></td>-->
                                    <!--<td><a href="AccountingLegalAndPhysical.vue"> {{result.espSerialNumber}}</a></td>-->
                                    <td>
                                         <label class="font-weight-bold" style="color: #000; font-style: italic">Жами:
                                            {{(result.totalAmountQQS)  | currency('', 2, { thousandsSeparator: ' ' })}}
                                         </label>
                                        <label class="font-weight-bold" style="color: red;">Б.М.С:
                                            {{(result.totalAmountQQS - result.paid)  | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </label>
                                        <template v-if="result.totalAmountQQS-result.paid>0">
                                            <center>
                                                <input type="checkbox" v-if="!result.vatPaidDate"
                                                       v-model="result.vatPaidEvaluationObjectId"
                                                       @click="onClickSelectObject(result.id, result.qqsAmount, result.totalAmountQQS, result.paid, $event)"
                                                       @change="onChangeSelectObject(result, $event)"
                                                       style="transform : scale(2); "/>
                                            </center>
                                        </template>
                                    </td>
                                    <td>{{result.paymentDocumentDate}}</td>
                                    <td>{{result.paymentDocumentNumber}}</td>
                                    <td>{{result.paid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.paymentSource}}</td>
                                    <td>
                                        <modal v-if="showModal">
                                            <h3 slot="header">{{$t("accounting.account.registrationPayDoc")}}</h3>
                                            <div slot="body">
                                                <div>
                                                    <label>{{$t("accounting.account.date")}}</label>
                                                    <datepicker
                                                            class="form-control"
                                                            format="dd/MM/yyyy"
                                                            v-model="newItem.paymentDocumentDate"
                                                            :clear-button="true"
                                                    ></datepicker>
                                                </div>
                                                <label>{{$t("accounting.account.totalAmount")}}</label>
                                                <numeric-input v-model="newItem.price" :precision="2" required></numeric-input>

                                                <label>{{$t("accounting.account.number")}}</label>
                                                <input type="text" class="form-control" id="paymentDocumentNumber"
                                                       name="paymentDocumentNumber"
                                                       v-model="newItem.paymentDocumentNumber" placeholder=" Раками"
                                                       required>
                                            </div>
                                            <div slot="footer" style="width: 100%;">
                                                <button style="float:right" type="button" class="all-btn delete-btn"
                                                        v-on:click="closeModal()"> Бекор қилиш
                                                </button>
                                                <button style="float:left" type="button" class="all-btn add-btn"
                                                        data-dismiss="modal"
                                                        v-on:click="saveModal()"> Сақлаш
                                                </button>
                                            </div>

                                        </modal>
                                        <!--<button type="button" class="all-btn" v-on:click="openModal(result.id)" v-if="hasPermission('ACCOUNTING_PAYMENT_INPUT')">-->
                                            <!--Киритиш-->
                                        <!--</button>-->
                                    </td>
                                    <td>
                                        <button type="button" class="all-btn" v-if="hasPermission('ACCOUNTING_PAYMENT_LIST')"
                                                @click="openModalModalTable(result.id)">Кўриш
                                        </button>
                                    </td>
                                    <!--<td :class="[result.vatPaidDate?'vat-paid':'vat-unpaid']">-->
                                        <!--<center>-->
                                        <!--<span v-if="result.vatPaidDate!=null">{{result.vatPaidDate}}</span><br/>-->
                                        <!--<span v-if="result.vatPaidPaymentOrder!=null">{{result.vatPaidPaymentOrder}}</span>-->
                                        <!--<input type="checkbox" v-if="!result.vatPaidDate"-->
                                               <!--v-model="result.vatPaidEvaluationObjectId"-->
                                        <!--@change="setVatPay(result.id, result.qqsAmount, $event)"/>-->
                                        <!--</center>-->
                                    <!--</td>-->
                                    <td>{{result.unpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.creditor | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                </tr>
                            </template>
                            </tbody>
                            <tfoot>
                            <tr v-if="loadingTotal">
                                <loading2 style="" v-if="loadingTotal"></loading2>
                            </tr>
                            <tr v-if="!loadingTotal">
                                <td colspan="3" class="font-weight-bold">Жами сумма : <span>{{tableTotalValue.evaluationObjTotal}}</span></td>
                                <td colspan="12" class="font-weight-bold"></td>
                                <td class="font-weight-bold">{{tableTotalValue.contractTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="3"></td>
                                <td class="font-weight-bold">{{tableTotalValue.contractTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold"></td>
                                <td class="font-weight-bold">{{tableTotalValue.totalAmountTaxPercentQQSSum | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="2"></td>
                                <td class="font-weight-bold">{{tableTotalValue.totalContractQQS | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="2"></td>
                                <td class="font-weight-bold">{{tableTotalValue.peidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="3"></td>
                                <td colspan="1"></td>
                                <td class="font-weight-bold">{{tableTotalValue.debtorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.creditorTotal | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-sm-10 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                        <!--<div class="col-sm-2 pt-3 pb-3 pull-right">-->
                            <!--<span class="font-weight-bold">Total {{results.total}}</span>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

    </b-modal>
</template>


<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, format_date} from '@/shared/utils';
    import Modal from '@/components/Modal.vue';
    import PaymentDocumentList from '@/views/accounting/PaymentDocumentList';
    import VatPaymentModal from '@/views/accounting/VatPaymentModal';
    import Loading2 from '@/views/Loading2';
    import bModal from 'bootstrap-vue/es/components/modal/modal'

    // export const
    export default {
        // template: '#doc-modal-template',
        name: "IpotekaCreditTransactionBindView",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            PaymentDocumentList,
            Modal,
            VatPaymentModal,
            Loading2,
            bModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                customerFilter: initFilterModel(),
                provinceFilter: initFilterModel(),
                results: null,
                organization: this.$t("accounting.account.organization"),
                customers: [],
                evlObjectTypes: [],
                showModal: false,
                showModalTable: false,
                show: false,
                newItem: {
                    paymentDocumentDate: null,
                    price: 0,
                    paymentDocumentNumber: null,
                    evaluationObjectId: null,
                    evaluationPaymentSource: 'MANUAL'
                },
                modolTables: [],
                province: {},
                region: {},
                provinces: [],
                regions: [],
                tableTotalValue: [],
                cadastreSections: [],
                employees: [],
                organizationListValue: {},
                loadingTotal: false,
                regionalLeaderProvince: null,
                ippotekaTransactionData: null,
                selectSumma: 0,
                evaluationObjects: []
            }
        },
        methods: {
            okBtn(/*data*/) {
                console.log("777777");

            },
            searchByFilter() {
                this.filter.page.page = 1;
                this.initList();
                this.initTableTotal();
            },
            initList() {
                const vm = this;
                this.selectSumma = 0;
                this.evaluationObjects = [];

                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.filter.province = regionalLeaderProvince;
                    vm.regionalLeaderProvince = regionalLeaderProvince;
                }
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.loading = true;
                this.init();
                console.log(this.filter);
                this.$http.post('admin/ipoteka/evaluation-objects-list', this.filter).then(res => {
                    vm.results = res.data;
                    vm.loading = false;
                }, err => {
                    console.log(err);
                    vm.loading = false;
                });

            },
            format_date(value){
                if (value) {
                    return format_date(value)
                }
                return null;
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },
            initTableTotal() {
                // const vm = this;
                // const regionalLeader = vm.$store.state.profile.regionalLeader;
                // if (regionalLeader){
                //     const regionalLeaderProvince = regionalLeader.userProvinces[0];
                //     vm.filter.province = regionalLeaderProvince;
                //     vm.regionalLeaderProvince = regionalLeaderProvince;
                // }
                // this.loading = true;
                // this.loadingTotal = true;
                // this.$http.post('/account/list/data/total', this.filter)
                //     .then(res => {
                //         this.loadingTotal = false;
                //         console.log(res);
                //         const initData = res.data;
                //         vm.tableTotalValue = initData.dataTotal;
                //         vm.loading = false;
                //     },(err) => {
                //         console.log(err);
                //         vm.loading = false;
                //     })
            },
            getOrganizationType() {
                const vm = this;
                this.loading = true;
                this.$http.get('/account/organizationType')
                    .then(res => {
                        const initData = res.data;
                        if (!vm.filter.organizationType && initData.data && initData.data.length < initData.total && initData.data.length > 0) {
                            vm.filter.organizationType = initData.data[0].code;
                            vm.organization = initData.data[0].displayName
                        }
                        vm.organizationListValue = initData;
                        this.initList();
                        vm.loading = false;
                    }, (err) => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            openModal(id) {
                this.newItem.paymentDocumentDate = '';
                this.newItem.price = 0;
                this.newItem.paymentDocumentNumber = '';
                this.newItem.evaluationObjectId = id;
                this.showModal = true;
            },
            closeModal() {
                this.showModal = false;
            },
            saveModal: function () {
                this.loading = true;
                if (this.newItem.price > 0 && this.newItem.paymentDocumentNumber != "" && this.newItem.paymentDocumentDate != "") {
                    this.$http.post('/payment/documents/save', this.newItem).then(res => {
                        this.showModal = false;
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('accounting.accountMessages.success'),
                            type: 'success'
                        });
                        this.loading = false;
                        this.initList();
                        this.initTableTotal();
                        console.log(res.data);//todo tegmanglar
                    }, err => {
                        this.loading = false;
                        this.showModal = false;
                        console.log(err);
                    });
                } else {
                    this.showModal = false;
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('accounting.accountMessages.error'),
                        type: 'error'
                    });
                    this.loading = false;
                }
            },
            openModalModalTable(id) {
                this.$eventBus.$emit('showPaymentDocumentListModal', {id: id});
            },
            showPaymentDocumentEditModal(data) {
                this.showModalTable = false;
                this.$eventBus.$emit('showPaymentDocumentEditModal', data);
            },

            closeModalTable() {
                this.showModalTable = false;
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onProvinceGetRegionsChange() {
                let regions = [];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
                // this.filter.region = null;
                this.searchByFilter();
            },
            onOrganizationTypeChange() {
                let organization =null;
                if (this.filter.organizationType==null || this.filter.organizationType==='') {
                    this.$delete(this.filter, 'organizationType');
                }
                if (this.filter.organizationType && this.organizationListValue.data && this.organizationListValue.data.length > 0) {
                    this.organizationListValue.data.forEach((organizationListValue) => {
                        if (organizationListValue.code === this.filter.organizationType) {
                            organization = organizationListValue.displayName;
                        }
                    });
                }
                this.organization = organization;
                this.searchByFilter();
            },
            // reportXslx: function () {
            //     this.$http.post('/getAccountingReportExcel/xls/FITMENT_REPORT_VALUABLE_XLS_BUX/',this.filter, {responseType: 'arraybuffer'})
            //         .then(res => {
            //             let blob = new Blob([res.data], {type: 'application/xlsx'});
            //             let link = document.createElement("a");
            //             link.href = window.URL.createObjectURL(blob);
            //             link.download = 'Xisobot.xlsx';
            //             link.click();
            //         }, err => {
            //             console.log(err);
            //         });
            // },
            onClickSelectObject(id, qqsAmount, totalAmountQQS, paid, $event) {
                qqsAmount = parseFloat(qqsAmount);
                let amountToPay = parseFloat(totalAmountQQS) - paid;
                const value = $event.target.checked;
                if (value) {
                    let summa = parseFloat(this.ippotekaTransactionData.reminderAfterSharing);
                    let sumSelected = 0;
                    this.evaluationObjects.forEach((item) => {
                        sumSelected+=item.amount;
                    });

                    //sumSelected = parseFloat(sumSelected.toFixed(2));
                    const checkAmount = parseFloat((sumSelected + amountToPay).toFixed(2));
                    if (this.evaluationObjects.length<=1) {
                        if (sumSelected>=summa) {
                            $event.preventDefault();
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: summa + ' дан куп булмаслиги керак \n' + 'танланган ' + parseFloat(this.selectSumma.toFixed(2)),
                                type: 'warning',
                            });
                        }
                    } else if (checkAmount> summa){
                        $event.preventDefault();
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: summa + ' дан куп булмаслиги керак \n' + 'танланган ' + parseFloat(this.selectSumma.toFixed(2)),
                            type: 'warning',
                        });
                    }
                    console.log(this.evaluationObjects);
                }
            },
            onChangeSelectObject(result, $event) {
                let id = result.id;
                let evlObjectType = result.evlObjectTypeDto.code;
                let paid = parseFloat(result.paid);
                let amountToPay = parseFloat(result.totalAmountQQS) - paid;
                const value = $event.target.checked;
                let summa = this.ippotekaTransactionData.reminderAfterSharing;

                const item = this.evaluationObjects.filter((option, /*index*/) => {
                    return option.id === id;
                })[0];
                var index = this.evaluationObjects.indexOf(item);

                if (value) {
                    if ((this.selectSumma + amountToPay) > summa) {
                        this.selectSumma += summa;
                        if (index === -1) {
                            this.evaluationObjects.push({
                                id: id,
                                evlObjectType: evlObjectType,
                                amount: summa
                            });
                        }
                    } else {
                        const checkAmount = parseFloat((this.selectSumma + amountToPay).toFixed(2));
                        if (summa >= checkAmount) {
                            this.selectSumma += amountToPay;
                            if (index === -1) {
                                this.evaluationObjects.push({
                                    id: id,
                                    evlObjectType: evlObjectType,
                                    amount: amountToPay
                                });
                            }
                        }
                    }
                } else {
                    if (index >= 0) {
                        this.selectSumma -= item.amount;
                        this.evaluationObjects.splice(index, 1);
                    }
                    console.log("item = ", item);
                }
                console.log("this.evaluationObjects = ");
                console.log(this.evaluationObjects);
            },
            bindTransactionToObject: function () {
                if (this.evaluationObjects.length > 0) {
                    const data = {
                        id: this.ippotekaTransactionData.id,
                        evaluationObjects: this.evaluationObjects
                    };
                    this.loading = true;
                    this.$http.post('admin/ipoteka/save-evaluation-objects', data).then(res => {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: res.data.message,
                            type: 'success'
                        });
                        this.loading = false;
                        this.initList();
                        this.initTableTotal();
                        this.$refs['ipoteka-bank-transaction-add-edit-modal'].hide();
                        this.$eventBus.$emit('showIpotekaCreditTransactionsList', res.data);
                        console.log(res.data);//todo tegmanglar
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
                }
            },
            getOpenLink(result) {
                if (!result.evlObjectTypeDto){
                    return "";
                }
                if (result.evlObjectTypeDto.code === 'Auto') {
                    return process.env.VUE_APP_WEB_URL + 'automulti/view?autoId=' + result.id;
                } else if (result.evlObjectTypeDto.code === 'Fitment') {
                    return process.env.VUE_APP_WEB_URL + 'fitment/view/' + result.id;
                } else if (result.evlObjectTypeDto.code === 'Building'){
                    return '/real-estate/view/' + result.id;
                } else if (result.evlObjectTypeDto.code === 'Asset'){
                    return '/asset/view/' + result.id;
                }
                return "";
            },


        },
        created() {
            // var d = new Date();
            // var currMonth = d.getMonth();
            // var currYear = d.getFullYear();
            // this.filter.startDate = new Date(currYear, currMonth-1, 1);
            // this.filter.endDate = new Date(currYear, currMonth, d.getDate());
            this.filter.paymentStatus = "UNPAID";

            this.$eventBus.$on('showIpotekaCreditTransactionBindView', (data) => {
                console.log(data);
                this.filter.identificationNumber = data.inn_DB;
                this.ippotekaTransactionData = data;
                this.selectSumma = 0;
                // this.initList();
                this.getOrganizationType();
                this.initTableTotal();

                this.$refs['ipoteka-bank-transaction-add-edit-modal'].show();
            });
            // this.initList();
            // this.getOrganizationType();
            // this.initTableTotal();
        }
    }
</script>

<style scoped>

    .scroll-card-body {
        overflow-x:scroll;
        overflow-y:visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
    }

    .vat-paid {
        background-color: #abc41c;
    }

    .vat-unpaid {
        background-color: transparent;
    }

    .tdunpaid {
        background-color: transparent;
    }


</style>
